import { useEffect, useState } from 'react';
import { searchService } from '@services/search.service';
import { SEARCH } from '@constants/search';

/**
 * Debounced query suggestions. Returns nothing when the service has nothing —
 * the previous version fell back to a hardcoded English list ("hr policies
 * manual"), so a failing endpoint showed users invented suggestions that
 * matched no document.
 */
export function useSearchSuggestions(query: string): string[] {
  const [suggestions, setSuggestions] = useState<string[]>([]);

  useEffect(() => {
    const trimmed = query.trim();
    if (!trimmed) {
      setSuggestions([]);
      return;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const results = await searchService.getSuggestions(trimmed, SEARCH.SUGGESTION_LIMIT);
        if (!cancelled) setSuggestions(results.map((item) => item.text));
      } catch {
        if (!cancelled) setSuggestions([]);
      }
    }, SEARCH.SUGGESTION_DEBOUNCE_MS);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [query]);

  return suggestions;
}
